var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuoteOpen = function SvgQuoteOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bb3d4d5e-bb6e-4548-8590-8e9bbfdbc2d6",
    "data-name": "Layer 1",
    width: 53.367,
    height: 39.516,
    viewBox: "0 0 53.367 39.516",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.773,39.891V25.055q0-10.548,4.993-16.664Q10.829,2.273,20.461.375V7.688q-7.171,2.25-9.633,7.734A12.543,12.543,0,0,0,9.773,21.4H20.812V39.891Zm53.016-32.2q-7.1,2.18-9.562,7.874A11.1,11.1,0,0,0,43.1,21.4H54.141V39.891H34.1V25.055q0-10.687,5.132-16.735,5.2-6.047,14.555-7.945Z",
    transform: "translate(-0.773 -0.375)",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuoteOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quote-open.14b05706.svg";
export { ForwardRef as ReactComponent };